import React from "react";

const About = () => {
  return <>About page</>;
};

export { About };
